import notAuthorized from "../../Assests/9264822.png";
import Button from "../../components/GButton/Button";


export default function NotData () {

    return (
        <div className="flex flex-col justify-center items-center sm:mt-5 mt-5 p-6 gap-6">
            <div className="sm:w-[70%] w-full flex justify-center items-center ">
                <img  src={notAuthorized} alt="not-authorized" className="h-60 "/>
            </div>
            <div>
                <h1 className="text-[20px] sm:text-[25px] text-white font-bold">
                   It seems that there is no data at the moment.
                </h1>
            </div>
        </div>
    )
}